module.exports = __webpack_public_path__ + "static/rcc-knb61-orr-graph-mobile-1db29a443fcc04a9c9109b0ef4dcf8fd.png";